import $ from 'jquery';
import * as stickyFilter from './stickyFilter';
import { scrollToId } from './scrollTo';

export const init = () => {
	const $heroSticky = $('.hero .sticky-component'),
		$servicesList = $('.js-services-list');

	if (!$servicesList.length || !$heroSticky.length) {
		return;
	}

	///////////////////////////////////////////////////////////////////////////////
	/// CONSTANTS AND VARIABLES
	///////////////////////////////////////////////////////////////////////////////

	const SERVICE_URL_KEY = 'category',
		ALL_SERVICES_URL_VALUE = 'all',
		SERVICES_GRID_TITLE_ID = '#services-title',
		URL_KEY = 'category',
		urlSearchParams = new URLSearchParams(window.location.search),
		$filterBtn = $heroSticky.find('.btn'),
		$dropdown = $heroSticky.find('.js-dropdown');

	///////////////////////////////////////////////////////////////////////////////
	/// INITIALIZATION
	///////////////////////////////////////////////////////////////////////////////

	initFilter();

	$filterBtn.on('click', function () {
		const selectedCategoryCodeName = stickyFilter.getDropdownSelectedItemCodeName($dropdown);

		stickyFilter.updateSearchUrl(selectedCategoryCodeName, urlSearchParams, URL_KEY);
		filterShownCategories(selectedCategoryCodeName);
		scrollToId(SERVICES_GRID_TITLE_ID);
	});

	///////////////////////////////////////////////////////////////////////////////
	/// HELPERS
	///////////////////////////////////////////////////////////////////////////////

	function initFilter() {
		const selectedCategoryCodeName = urlSearchParams.get(SERVICE_URL_KEY);

		if (!selectedCategoryCodeName) return;

		filterShownCategories(selectedCategoryCodeName);
		stickyFilter.selectDropdownItem(selectedCategoryCodeName, $dropdown, urlSearchParams, URL_KEY);
	}

	function filterShownCategories(selectedCategoryCodeName) {
		if (selectedCategoryCodeName === ALL_SERVICES_URL_VALUE) {
			// show all
			$servicesList.children().show();
			return;
		}

		$servicesList.children().each(function () {
			const $this = $(this),
				category = $this.children('.service').first().data('category');

			if (category === selectedCategoryCodeName) {
				$this.show();
			} else {
				$this.hide();
			}
		});
	}
};
